import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { deposit } from "../../../../../../services/pos/Tables";

const DepositModal = ({ open, onClose, bank, onSuccess }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [formData, setFormData] = useState({
    bank_id: bank?.id || "",

    amount: "",
    deposit_title: "",
    deposit_description: "",
    transaction_date: "",
    root_id: "",
  });

  // تحديث bank_id و root_id تلقائيًا عند تغيير البنك
  useEffect(() => {
    if (bank) {
      setFormData((prev) => ({
        ...prev,
        bank_id: bank.id || "",
        root_id: bank.root_id || "",
      }));
    }
  }, [bank]);

  // إعادة تعيين النموذج عند الفتح
  useEffect(() => {
    if (open) {
      setFormData({
        bank_id: bank?.id || "",
        amount: "",
        deposit_title: "",
        deposit_description: "",
        transaction_date: "",
        root_id: bank?.root_id || "",
      });
    }
  }, [open, bank]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      ...formData,
      bank_id: bank?.id || "",
      root_id: bank?.root_id || "",
    };

    const { amount, deposit_title, transaction_date } = payload;

    if (!amount || !deposit_title || !transaction_date) {
      alert("❌ يرجى ملء جميع الحقول المطلوبة.");
      return;
    }

    try {
      console.log("🚀 إرسال البيانات:", payload); // ✅ لمراجعة البيانات المرسلة
      await deposit(payload);
      alert("✅ تم تسجيل عملية الإيداع بنجاح.");
      onSuccess?.();
      onClose?.();
    } catch (error) {
      console.error("❌ فشل في عملية الإيداع:", error);
      alert(`❌ فشل في عملية الإيداع:\n${error?.message || ""}\n${error?.error || ""}`);
    }
  };


  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          m: { xs: 0, sm: 2 },
          maxHeight: { xs: "100%", sm: "90vh" },
          width: { xs: "100%", sm: "auto" },
        }
      }}
    >
      <DialogTitle sx={{ 
        fontSize: { xs: "18px", sm: "20px", md: "24px" },
        py: { xs: 1.5, sm: 2 },
        fontWeight: 600,
      }}>
        إيداع في الخزنة
      </DialogTitle>
      <DialogContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Box sx={{ mt: { xs: 0.5, sm: 1 } }}>
          <Typography 
            variant={isMobile ? "subtitle1" : "h6"} 
            mb={{ xs: 1.5, sm: 2 }}
            sx={{ fontSize: { xs: "16px", sm: "18px", md: "20px" } }}
          >
            تسجيل عملية إيداع
          </Typography>
          <Box display="flex" flexDirection="column" gap={{ xs: 1.5, sm: 2 }}>
            <TextField
              label="المبلغ"
              name="amount"
              type="number"
              value={formData.amount}
              onChange={handleChange}
              fullWidth
              size={isMobile ? "small" : "medium"}
              InputLabelProps={{ 
                style: { fontSize: isMobile ? "14px" : "16px" } 
              }}
              InputProps={{
                style: { fontSize: isMobile ? "14px" : "16px" }
              }}
            />
            <TextField
              label="عنوان الإيداع"
              name="deposit_title"
              value={formData.deposit_title}
              onChange={handleChange}
              fullWidth
              size={isMobile ? "small" : "medium"}
              InputLabelProps={{ 
                style: { fontSize: isMobile ? "14px" : "16px" } 
              }}
              InputProps={{
                style: { fontSize: isMobile ? "14px" : "16px" }
              }}
            />
            <TextField
              label="وصف الإيداع"
              name="deposit_description"
              value={formData.deposit_description}
              onChange={handleChange}
              fullWidth
              multiline
              rows={isMobile ? 2 : 3}
              size={isMobile ? "small" : "medium"}
              InputLabelProps={{ 
                style: { fontSize: isMobile ? "14px" : "16px" } 
              }}
              InputProps={{
                style: { fontSize: isMobile ? "14px" : "16px" }
              }}
            />
            <TextField
              label="تاريخ العملية"
              name="transaction_date"
              type="date"
              value={formData.transaction_date}
              onChange={handleChange}
              InputLabelProps={{ 
                shrink: true,
                style: { fontSize: isMobile ? "14px" : "16px" } 
              }}
              InputProps={{
                style: { fontSize: isMobile ? "14px" : "16px" }
              }}
              fullWidth
              size={isMobile ? "small" : "medium"}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ 
        p: { xs: 2, sm: 2 },
        gap: { xs: 1, sm: 1 },
        flexDirection: { xs: "column-reverse", sm: "row" },
      }}>
        <Button 
          onClick={onClose}
          fullWidth={isMobile}
          size={isMobile ? "medium" : "large"}
          sx={{ fontSize: { xs: "14px", sm: "15px" } }}
        >
          إلغاء
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleSubmit}
          fullWidth={isMobile}
          size={isMobile ? "medium" : "large"}
          sx={{ fontSize: { xs: "14px", sm: "15px" } }}
        >
          تسجيل الإيداع
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DepositModal;
